import {combineReducers} from "@reduxjs/toolkit";

import appSlice from './reducers/app';
import authSlice from './reducers/auth';
import usageDataSlice from './reducers/usageData';
import ImpersonificationSlice from './reducers/impersonification';
import languageSlice from './reducers/language';
import contractSlice from './reducers/contracts';
import listsSlice from './reducers/lists';
import sociSlice from './reducers/soci';
import caseGeneratorCurrentStepSlice from "./reducers/caseGeneratorCurrentStep";
// || (() => null) added to remove the error when testing
const rootReducer = combineReducers({
  app: appSlice || (() => null) ,
  auth: authSlice || (() => null) ,
  usageData: usageDataSlice,
  impersonificationData: ImpersonificationSlice,
  language: languageSlice,
  contracts: contractSlice || (() => null) ,
  lists: listsSlice,
  soci:sociSlice,
  caseGeneratorCurrentStep : caseGeneratorCurrentStepSlice,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
